/** National digits only (no country prefix). Tune bounds per product requirements. */
export const NATIONAL_PHONE_MIN_DIGITS = 7;
export const NATIONAL_PHONE_MAX_DIGITS = 15;

/**
 * Validates a string of national phone digits (after country selector).
 * Accepts only ASCII digits; length is inclusive between min and max.
 */
export function isValidNationalPhoneDigits(digits: string): boolean {
    if (!digits.length) return false;
    if (!/^\d+$/.test(digits)) return false;
    return digits.length >= NATIONAL_PHONE_MIN_DIGITS && digits.length <= NATIONAL_PHONE_MAX_DIGITS;
}

/**
 * Sanitize phone input: digits only, optional max length for UX cap.
 */
export function sanitizeNationalPhoneInput(raw: string, maxDigits = 15): string {
    return raw.replace(/\D/g, '').slice(0, maxDigits);
}
